import React, { Component } from "react";

import { getHReviewScreenURL } from "../../../utils";

// MVE-32: the classification screen runs in a cross-origin iframe and cannot
// read the CertFocus JWT itself, so the host hands its token over on load via
// postMessage. The token is deliberately not put in the iframe URL, which would
// leak it into browser history and proxy access logs.
const HOST_ACCESS_TOKEN_MESSAGE = "h-classify:access-token";
const AUTH_TOKEN_STORAGE_KEY = "auth-token";

class HClassify extends Component {
  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();
    this.retryTimers = [];
  }

  componentWillUnmount() {
    this.retryTimers.forEach((timer) => clearTimeout(timer));
    this.retryTimers = [];
  }

  getHostReviewScreenOrigin = () => {
    try {
      return new URL(getHReviewScreenURL()).origin;
    } catch (err) {
      return "";
    }
  };

  getAccessToken = () => {
    try {
      return (
        localStorage.getItem(AUTH_TOKEN_STORAGE_KEY) ||
        sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY) ||
        ""
      );
    } catch (err) {
      return "";
    }
  };

  handleIframeLoad = () => {
    // The frame's React listener may attach just after the load event, so post
    // a few times; a duplicate handoff only overwrites the in-memory ref.
    [0, 300, 1000].forEach((delay) => {
      const timer = setTimeout(this.postAccessToken, delay);
      this.retryTimers.push(timer);
    });
  };

  postAccessToken = () => {
    const token = this.getAccessToken();
    const targetOrigin = this.getHostReviewScreenOrigin();
    const frameWindow =
      this.iframeRef.current && this.iframeRef.current.contentWindow;

    if (!token || !targetOrigin || !frameWindow) return;

    frameWindow.postMessage(
      { type: HOST_ACCESS_TOKEN_MESSAGE, token },
      targetOrigin
    );
  };

  render() {
    const url = `${getHReviewScreenURL()}/review/documents/classifier`;
    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          ref={this.iframeRef}
          src={url}
          title="H-Classify Application"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          sandbox="allow-scripts allow-same-origin"
          onLoad={this.handleIframeLoad}
        />
      </div>
    );
  }
}

export default HClassify;
